import React from 'react';

import Spinner from '@atlaskit/spinner/spinner';

import { type Appearance, type ButtonSpacing } from '../types';

function getIconSpacing(spacing?: ButtonSpacing) {
	switch (spacing) {
		case 'compact':
			return 'small';
		default:
			return 'medium';
	}
}

function getSpinnerAppearance({
	appearance,
	isDisabled,
	isSelected,
}: {
	appearance?: Appearance;
	isDisabled?: boolean;
	isSelected?: boolean;
}): 'inherit' | 'invert' {
	if (isDisabled || isSelected) {
		return 'inherit';
	}
	if (
		appearance === 'primary' ||
		appearance === 'rovo' ||
		appearance === 'danger' ||
		appearance === 'discovery'
	) {
		return 'invert';
	}
	return 'inherit';
}

export default function renderLoadingOverlay({
	appearance,
	spacing,
	isDisabled,
	isSelected,
	testId,
}: {
	spacing?: ButtonSpacing;
	appearance?: Appearance;
	isDisabled?: boolean;
	isSelected?: boolean;
	testId?: string;
}): React.JSX.Element {
	return (
		<Spinner
			size={getIconSpacing(spacing)}
			appearance={getSpinnerAppearance({
				appearance,
				isDisabled,
				isSelected,
			})}
			testId={testId ? `${testId}--loading-spinner` : undefined}
		/>
	);
}
